module.exports = __webpack_public_path__ + "static/media/save_hover.02e6111c.svg";